// Newsletter subscription handler
(function() {
    'use strict';
    
    // Wait for DOM ready
    function ready(fn) {
        if (document.readyState !== 'loading') {
            fn();
        } else {
            document.addEventListener('DOMContentLoaded', fn);
        }
    }
    
    ready(function() {
        // Check if vars exist
        if (typeof voyapon_newsletter === 'undefined') {
            console.error('Newsletter vars not loaded');
            return;
        }
        
        // Get all newsletter forms
        var forms = document.querySelectorAll('.newsletter-form');
        
        // Attach handler to each form
        for (var i = 0; i < forms.length; i++) {
            forms[i].onsubmit = function(e) {
                e.preventDefault();
                
                var form = this;
                var emailInput = form.querySelector('input[name="email"]');
                var submitBtn = form.querySelector('input[type="submit"]');
                
                if (!emailInput || !submitBtn) {
                    return false;
                }
                
                var email = emailInput.value.trim();
                if (!email) {
                    return false;
                }
                
                // Disable inputs
                emailInput.disabled = true;
                submitBtn.disabled = true;
                var originalText = submitBtn.value;
                submitBtn.value = voyapon_newsletter.sending || 'Sending...';
                
                // Create form data
                var formData = new FormData();
                formData.append('action', 'voyapon_newsletter_subscribe');
                formData.append('email', email);
                formData.append('nonce', voyapon_newsletter.nonce);
                
                // Send AJAX request
                var xhr = new XMLHttpRequest();
                xhr.open('POST', voyapon_newsletter.ajax_url, true);
                xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                
                xhr.onload = function() {
                    // Re-enable inputs
                    emailInput.disabled = false;
                    submitBtn.disabled = false;
                    submitBtn.value = originalText;
                    
                    if (xhr.status === 200) {
                        try {
                            var response = JSON.parse(xhr.responseText);
                            if (response.success) {
                                showMessage(form, voyapon_newsletter.success_message || 'Thank you!', 'success');
                                emailInput.value = '';
                            } else {
                                showMessage(form, response.data.message || voyapon_newsletter.error_message || 'Error occurred', 'error');
                            }
                        } catch (e) {
                            showMessage(form, 'Error processing response', 'error');
                        }
                    } else {
                        showMessage(form, 'Connection error', 'error');
                    }
                };
                
                xhr.onerror = function() {
                    emailInput.disabled = false;
                    submitBtn.disabled = false;
                    submitBtn.value = originalText;
                    showMessage(form, 'Connection error', 'error');
                };
                
                xhr.send(formData);
                
                return false;
            };
        }
        
        function showMessage(form, text, type) {
            // Remove existing message
            var existing = form.querySelector('.newsletter-message');
            if (existing) {
                existing.remove();
            }
            
            // Create message element
            var msg = document.createElement('div');
            msg.className = 'newsletter-message alert alert-' + (type === 'success' ? 'success' : 'danger') + ' mt-3';
            msg.textContent = text;
            form.appendChild(msg);
            
            // Auto remove after 5 seconds
            setTimeout(function() {
                if (msg.parentNode) {
                    msg.remove();
                }
            }, 5000);
        }
    });
})();